export default [
    {
        path: '/pos/stock-taking-ldn/:filter?',
        name: 'pos_stock_taking_ldn',
        meta: {
            title: 'Inventur',
            role: 'ROLE_POS_STOCKTAKING',
        },
        component: () => import('@src/pos/stock-taking-ldn'),
        props() {
            return { whs: 'LDN' };
        },
    },
    {
        path: '/pos/refill-recommendation/:filter?',
        name: 'pos_refill_recommendation_list',
        meta: {
            title: 'Artikel für VRSND',
            role: 'ROLE_POS_REFILL_RECOMMENDATION',
        },
        component: () => import('@src/pos/pos-refill-recommendation-list'),
    },
    {
        path: '/pos/print-price-label',
        name: 'pos_print_price_label',
        meta: {
            title: 'Labeln & Umlagern',
            role: 'ROLE_PRINT_PRICE_LABEL',
        },
        component: () => import('@src/pos/print-price-label.vue'),
    },
    {
        path: '/pos/print-bike-label',
        name: 'pos_print_bike_label',
        meta: {
            title: 'Bike Label',
            role: 'ROLE_PRINT_BIKE_LABEL',
        },
        component: () => import('@src/pos/print-bike-label.vue'),
    },
    {
        path: '/pos/printed-price-diff',
        name: 'pos_printed_price_diff',
        meta: {
            title: 'Preisänderungen',
            role: 'ROLE_PRINTED_PRICE_DIFFERENCE',
        },
        component: () => import('@src/pos/printed-price-difference.vue'),
    },
    {
        path: '/pos/express-pick',
        name: 'pos_express_pick',
        meta: {
            title: 'Expressaufträge',
            role: 'ROLE_EXPRESS_CREATE',
        },
        component: () => import('@src/express-pick/create-express-transfer-request.vue'),
    },
];
